import { render } from "./Team_legal_en.vue?vue&type=template&id=3c99bcc7&scoped=true"
import script from "./Team_legal_en.vue?vue&type=script&lang=js"
export * from "./Team_legal_en.vue?vue&type=script&lang=js"

import "./Team_legal_en.vue?vue&type=style&index=0&id=3c99bcc7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c99bcc7"

export default script